import {HTTP} from '@/CallAPI'
export default {
  getListChecklist (page = 1, per_page = '', search = '', sort = '', status = '', organization_id = '', is_calendar = '', ctg = '') {
    return HTTP.get('checklists', {
      params: {
        page,
        per_page,
        search,
        sort,
        status,
        organization_id,
        is_calendar,
        ctg
      }
    })
  },

  showChecklist (checklist) {
    return HTTP.get('checklists/' + checklist.id)
  },

  createChecklist (checklist) {
    return HTTP.post('checklists', checklist)
  },

  addChecklistItem (checklist, chk_item_id = {}) {
    return HTTP.post('checklists/' + checklist.id + '/checklist-items', {chk_item_id})
  },

  destroyChecklist (checklist) {
    return HTTP.delete('checklists/' + checklist.id)
  },

  updateChecklist (checklist) {
    return HTTP.put('checklists/' + checklist.id, checklist)
  },

  approvalChecklist (checklist) {
    return HTTP.post('checklists/' + checklist.id + '/approval')
  },

  rejectChecklist (checklist) {
    return HTTP.post('checklists/' + checklist.id + '/rejection')
  },

  inProgressChecklist (checklist) {
    return HTTP.post('checklists/' + checklist.id + '/in-progress')
  },

  closeChecklist (checklist, closing_date = '') {
    return HTTP.post('checklists/' + checklist.id + '/close', {closing_date})
  },

  correctiveChecklist (checklist, end_corrective_date = '', checklist_item = []) {
    return HTTP.post('checklists/' + checklist.id + '/corrective', {end_corrective_date, checklist_item})
  },

  duplicateChecklist (checklist) {
    return HTTP.post('checklists/' + checklist.id + '/duplicates')
  }
}



// WEBPACK FOOTER //
// ./src/service/checklist.js